// Auto-extracted from SellerAnalytics.jsx
import { C } from "../../lib/theme";
import { Card } from "../../components/Card";
import { Icon } from "../../components/Icon";
import { fmtK, fmtKShort } from "../../lib/money";
import { resolveImage } from "../../lib/images";

export function RatingBars({ dist, total }) {
  return (
    <div style={{ display: "grid", gap: 6 }}>
      {[5, 4, 3, 2, 1].map((star) => {
        const count = dist[star - 1];
        const pct = total > 0 ? (count / total) * 100 : 0;
        return (
          <div key={star} style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ fontSize: 11, color: C.muted, fontWeight: 700, width: 24 }}>{star}★</div>
            <div style={{ flex: 1, height: 6, background: C.cream, borderRadius: 3, overflow: "hidden" }}>
              <div
                style={{
                  width: `${pct}%`,
                  height: "100%",
                  background: star >= 4 ? C.hunter : star === 3 ? C.amber : C.red,
                  borderRadius: 3,
                }}
              />
            </div>
            <div style={{ fontSize: 11, color: C.muted, fontWeight: 700, width: 28, textAlign: "right" }}>
              {count}
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ============= KPI + Metric row =============
